// extracted by mini-css-extract-plugin
module.exports = {"imageHeading":"ImageHeading_imageHeading__Y1_vu"};